import { faRotateRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect, useRef } from "react";

const CaptchaLogin = ({ remitCaptcha }) => {
  const [captchaText, setCaptchaText] = useState("");
  const [userInput, setUserInput] = useState("");
  const [message, setMessage] = useState("");
  const canvasRef = useRef(null);

  const generateCaptchaText = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let text = "";
    for (let i = 0; i < 5; i++) {
      text += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return text;
  };

  const drawCaptcha = (text) => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = "#f0f0f0";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.font = "28px Arial";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    for (let i = 0; i < text.length; i++) {
      const x = 40 + i * 40;
      const y = 28;
      const angle = Math.random() * 0.3 - 0.15;
      const color = `hsl(${Math.random() * 360}, 100%, 50%)`;

      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.fillStyle = color;
      ctx.fillText(text[i], 0, 0);
      ctx.restore();
    }

    for (let i = 0; i < 30; i++) {
      ctx.fillStyle = `rgba(0,0,0,${Math.random()})`;
      ctx.fillRect(
        Math.random() * canvas.width,
        Math.random() * canvas.height,
        2,
        2
      );
    }
  };

  useEffect(() => {
    const text = generateCaptchaText();
    setCaptchaText(text);
    drawCaptcha(text);
  }, []);

  const onChangeCaptcha = (e) => {
    const val = e.target.value;
    setUserInput(val);
    if (remitCaptcha) {
      remitCaptcha({ captchaVerify: "PENDING" });
    }
    if (val.trim().length === 5) {
        if (val.toUpperCase() !== captchaText) {
            setMessage("Captcha verification failed!");
            refreshCaptcha();
            return;
        }       
        if (remitCaptcha) {
            setMessage("");
            remitCaptcha({ captchaVerify: "OK" });
        }
    }  
   
  };

  const refreshCaptcha = () => {
    const text = generateCaptchaText();
    setCaptchaText(text);
    drawCaptcha(text);
    setUserInput("");
    setMessage("");
    if (remitCaptcha) {
      remitCaptcha({ captchaVerify: "PENDING" });
    }
  };

  return (
    <div className="auth-captcha">
      <div className="auth-captcha-code">
        <div className="auth-captcha-canvas">
          <canvas
            ref={canvasRef}
            width="250"
            height="50"
          ></canvas>
        </div>
        <button
          type="button"
          onClick={refreshCaptcha}
          className="auth-captcha-refresh"
          aria-label="Refresh captcha"
        >
          <FontAwesomeIcon icon={faRotateRight} />
        </button>
      </div>
      <div className="auth-input auth-captcha-entry">
          <span><i className="fa fa-keyboard"></i></span>
          <input
            type="text"
            value={userInput}
            onChange={onChangeCaptcha}
            placeholder="Enter captcha code"
            maxLength="5"
            autoComplete="off"
          />
      </div>
      {message && <small className="auth-error">{message}</small>}
    </div>
  );
};

export default CaptchaLogin;
